import { FormControl, FormHelperText } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Controller, useFormContext } from 'react-hook-form';
import { isEmpty, isNotNull } from '../../../features/common/util.services';

export type ITextFieldProps = {
    label: string;
    name: string;
    type?: string;
    onActionEvent?: any;
    InputProps?: any;
    disabled?: boolean;
    required?: boolean;
    rules?: any;
    timeZone?: string;
}

const IDateField = (props: ITextFieldProps) => {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    const { control, register, setValue } = useFormContext();
    const onActionEvent = (event: any) => {
        const value = dayjs(event.$d);
        setValue(props.name, value);
        if (props.onActionEvent) {
            props.onActionEvent(value);
        }
    }

    return <div className="i-textfield">
        <Controller
            control={control}
            name={props.name}
            rules={{
                required: {
                    value: props.required,
                    message: "Required Field"
                },
                ...props.rules
            }}
            render={({ field, fieldState }) => (<FormControl fullWidth
                size="small">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        {...field}
                        {...register(props.name)}
                        value={field.value || null}
                        slotProps={{ textField: { size: 'small' } }}
                        format={'DD/MM/YYYY'}
                        timezone={isEmpty(props.timeZone) ? 'system' : props.timeZone}
                        onChange={onActionEvent}
                        label={props.label}
                        disabled={props.disabled}
                    />
                </LocalizationProvider>
                <FormHelperText error={isNotNull(fieldState.error)}>{fieldState.error ? fieldState.error.message : null}</FormHelperText>  </FormControl>
            )}
        />
    </div>

};

export default IDateField;